<template>
    <div class="patient-archive">
      <!-- <h2 class="page-title">患者档案管理</h2> -->
  
      <!-- 搜索表单区 -->
      <el-card class="search-card">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" :rules="searchRules" size="small">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="患者姓名" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入患者姓名" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="searchForm.idCard" placeholder="请输入身份证号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchPatient">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
  
      <!-- 搜索结果区 -->
      <el-card class="result-card" v-if="showSearchResult">
        <div class="card-header">
          <span>搜索结果</span>
          <el-button type="primary" icon="el-icon-download" @click="fetchPatientData">一键获取档案</el-button>
        </div>
  
        <el-table :data="searchResultList" border style="width: 100%" v-loading="searching">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="gender" label="性别" width="60"></el-table-column>
          <el-table-column prop="idType" label="证件类型" width="100"></el-table-column>
          <el-table-column prop="idCard" label="证件号码" width="180"></el-table-column>
          <el-table-column prop="medicalNum" label="病历号" width="120"></el-table-column>
          <el-table-column prop="birthDate" label="出生日期" width="120"></el-table-column>
          <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="viewPatientDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <div class="empty-result" v-if="searchResultList.length === 0 && !searching">
          <i class="el-icon-warning-outline"></i>
          <p>未找到匹配的患者记录</p>
        </div>
      </el-card>
  
      <!-- 患者详情 -->
      <el-card class="patient-detail-card" v-if="showPatientDetail">
        <div class="card-header">
          <div>
            <span class="header-title">患者档案详情</span>
            <el-tag size="small" type="success" v-if="patientDetail.archived">已建档</el-tag>
            <el-tag size="small" type="warning" v-else>未建档</el-tag>
          </div>
          <div>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="editPatient">编辑</el-button>
            <el-button size="small" type="success" icon="el-icon-printer" @click="printPatient">打印</el-button>
          </div>
        </div>
  
        <div class="patient-profile">
          <div class="profile-avatar">
            <img :src="patientDetail.avatar || defaultAvatar" alt="患者头像">
            <el-upload
              v-if="editMode"
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="profile-info">
            <div class="profile-header">
              <h3>{{ patientDetail.name }}</h3>
              <span class="medical-num">病历号: {{ patientDetail.medicalNum }}</span>
            </div>
            
            <el-descriptions :column="3" border size="small">
              <el-descriptions-item label="证件类型">{{ patientDetail.idType }}</el-descriptions-item>
              <el-descriptions-item label="证件号码">{{ patientDetail.idCard }}</el-descriptions-item>
              <el-descriptions-item label="性别">{{ patientDetail.gender }}</el-descriptions-item>
              <el-descriptions-item label="出生日期">{{ patientDetail.birthDate }}</el-descriptions-item>
              <el-descriptions-item label="年龄">{{ patientDetail.age }}岁</el-descriptions-item>
              <el-descriptions-item label="手机号码">{{ patientDetail.phone }}</el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
  
        <el-divider content-position="left">详细信息</el-divider>
  
        <el-form :model="patientDetail" ref="patientForm" label-width="100px" :disabled="!editMode">
          <el-tabs type="border-card">
            <el-tab-pane label="基础信息">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="国籍">
                    <el-select v-model="patientDetail.nationality" placeholder="请选择国籍">
                      <el-option label="中国" value="中国"></el-option>
                      <el-option label="美国" value="美国"></el-option>
                      <el-option label="其他" value="其他"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="民族">
                    <el-select v-model="patientDetail.ethnicity" placeholder="请选择民族">
                      <el-option label="汉族" value="汉族"></el-option>
                      <el-option label="满族" value="满族"></el-option>
                      <el-option label="蒙古族" value="蒙古族"></el-option>
                      <el-option label="藏族" value="藏族"></el-option>
                      <el-option label="维吾尔族" value="维吾尔族"></el-option>
                      <el-option label="其他" value="其他"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="婚姻状况">
                    <el-select v-model="patientDetail.maritalStatus" placeholder="请选择">
                      <el-option label="未婚" value="未婚"></el-option>
                      <el-option label="已婚" value="已婚"></el-option>
                      <el-option label="离异" value="离异"></el-option>
                      <el-option label="丧偶" value="丧偶"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="职业">
                    <el-input v-model="patientDetail.occupation" placeholder="请输入职业"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="常用地址">
                    <el-input v-model="patientDetail.address" placeholder="请输入常用地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
  
            <el-tab-pane label="联系人信息">
              <el-row :gutter="20">
                <el-col :span="24">
                  <h4>监护人信息</h4>
                  <el-divider></el-divider>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="监护人">
                    <el-input v-model="patientDetail.guardian.name" placeholder="请输入监护人姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="监护人电话">
                    <el-input v-model="patientDetail.guardian.phone" placeholder="请输入监护人电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="与患者关系">
                    <el-select v-model="patientDetail.guardian.relationship" placeholder="请选择关系">
                      <el-option label="父亲" value="父亲"></el-option>
                      <el-option label="母亲" value="母亲"></el-option>
                      <el-option label="配偶" value="配偶"></el-option>
                      <el-option label="子女" value="子女"></el-option>
                      <el-option label="其他" value="其他"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              
              <el-row :gutter="20">
                <el-col :span="24">
                  <h4>紧急联系人</h4>
                  <el-divider></el-divider>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系人">
                    <el-input v-model="patientDetail.emergency.name" placeholder="请输入紧急联系人姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系人电话">
                    <el-input v-model="patientDetail.emergency.phone" placeholder="请输入紧急联系人电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="与患者关系">
                    <el-select v-model="patientDetail.emergency.relationship" placeholder="请选择关系">
                      <el-option label="父亲" value="父亲"></el-option>
                      <el-option label="母亲" value="母亲"></el-option>
                      <el-option label="配偶" value="配偶"></el-option>
                      <el-option label="子女" value="子女"></el-option>
                      <el-option label="其他亲属" value="其他亲属"></el-option>
                      <el-option label="朋友" value="朋友"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            
            <el-tab-pane label="就诊记录">
              <el-table :data="patientDetail.visits || []" border style="width: 100%">
                <el-table-column prop="date" label="就诊日期" width="120"></el-table-column>
                <el-table-column prop="department" label="科室" width="120"></el-table-column>
                <el-table-column prop="doctor" label="医生" width="100"></el-table-column>
                <el-table-column prop="diagnosis" label="诊断"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === '已完成' ? 'success' : 'warning'">
                      {{ scope.row.status }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="viewVisitDetail(scope.row)">查看详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="empty-table-tip" v-if="!patientDetail.visits || patientDetail.visits.length === 0">
                <i class="el-icon-document"></i>
                <span>暂无就诊记录</span>
              </div>
            </el-tab-pane>
          </el-tabs>
          
          <div class="form-actions" v-if="editMode">
            <el-button type="primary" @click="savePatient">保存</el-button>
            <el-button @click="cancelEdit">取消</el-button>
          </div>
        </el-form>
      </el-card>
  
      <!-- 数据导入进度对话框 -->
      <el-dialog
        title="档案同步"
        :visible.sync="importDialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false">
        <div class="import-progress">
          <div class="progress-title">从HIS系统导入患者档案</div>
          <div class="progress-step">
            <div class="step-item" :class="{ active: importProgress >= 1, completed: importProgress > 1 }">
              <div class="step-icon">
                <i class="el-icon-user"></i>
              </div>
              <div class="step-label">获取基础信息</div>
            </div>
            <div class="progress-line" :class="{ active: importProgress >= 2 }"></div>
            <div class="step-item" :class="{ active: importProgress >= 2, completed: importProgress > 2 }">
              <div class="step-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="step-label">同步账户信息</div>
            </div>
            <div class="progress-line" :class="{ active: importProgress >= 3 }"></div>
            <div class="step-item" :class="{ active: importProgress >= 3, completed: importProgress > 3 }">
              <div class="step-icon">
                <i class="el-icon-collection"></i>
              </div>
              <div class="step-label">同步扩展信息</div>
            </div>
            <div class="progress-line" :class="{ active: importProgress >= 4 }"></div>
            <div class="step-item" :class="{ active: importProgress >= 4, completed: importProgress === 4 }">
              <div class="step-icon">
                <i class="el-icon-finished"></i>
              </div>
              <div class="step-label">完成</div>
            </div>
          </div>
          <div class="progress-message">{{ importMessage }}</div>
          <el-progress :percentage="importPercentage" :status="importStatus"></el-progress>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PatientArchive',
    data() {
      return {
        // 搜索相关
        searchForm: {
          name: '许昊然',
          idCard: '110101199001011234'
        },
        searchRules: {
          name: [{ required: true, message: '请输入患者姓名', trigger: 'blur' }],
          idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }]
        },
        searching: false,
        showSearchResult: false,
        searchResultList: [],
        
        // 患者详情相关
        showPatientDetail: false,
        editMode: false,
        patientDetail: {
          name: '',
          gender: '',
          age: '',
          birthDate: '',
          medicalNum: '',
          idType: '身份证',
          idCard: '',
          phone: '',
          nationality: '中国',
          ethnicity: '汉族',
          maritalStatus: '',
          occupation: '',
          address: '',
          archived: false,
          avatar: '',
          guardian: {
            name: '',
            phone: '',
            relationship: ''
          },
          emergency: {
            name: '',
            phone: '',
            relationship: ''
          },
          visits: []
        },
        
        // 导入相关
        importDialogVisible: false,
        importProgress: 0,
        importPercentage: 0,
        importMessage: '准备从HIS系统获取患者档案...',
        importStatus: '',
        
        // 其他
        defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
      }
    },
    methods: {
      // 搜索患者
      searchPatient() {
        this.$refs.searchForm.validate(valid => {
          if (valid) {
            this.searching = true;
            this.showSearchResult = true;
            // 模拟API请求延迟
            setTimeout(() => {
              // 假设搜索到了两个相似的结果
              if (this.searchForm.name === '许昊然' || this.searchForm.idCard === '110101199001011234') {
                this.searchResultList = [
                  {
                    name: '许昊然',
                    gender: '男',
                    idType: '身份证',
                    idCard: '110101199001011234',
                    medicalNum: 'P202001001',
                    birthDate: '1990-01-01',
                    phone: '13800138000'
                  },
                  {
                    name: '许昊然',
                    gender: '男',
                    idType: '身份证',
                    idCard: '110101199001011235',
                    medicalNum: 'P202001002',
                    birthDate: '1990-02-02',
                    phone: '13900139000'
                  }
                ];
              } else {
                this.searchResultList = [];
              }
              this.searching = false;
            }, 800);
          }
        });
      },
      
      // 重置表单
      resetForm() {
        this.$refs.searchForm.resetFields();
      },
      
      // 查看患者详情
      viewPatientDetail(patient) {
        // 模拟API请求获取详细信息
        this.showPatientDetail = true;
        this.editMode = false;
        
        // 假数据：设置基础信息
        this.patientDetail = {
          ...patient,
          age: this.calculateAge(patient.birthDate),
          nationality: '中国',
          ethnicity: '汉族',
          maritalStatus: '已婚',
          occupation: '工程师',
          address: '北京市海淀区中关村南大街5号',
          archived: true,
          avatar: '',
          guardian: {
            name: '苏雅婷',
            phone: '13800138001',
            relationship: '父亲'
          },
          emergency: {
            name: '林书辰',
            phone: '13800138002',
            relationship: '配偶'
          },
          visits: [
            {
              date: '2023-01-15',
              department: '内科',
              doctor: '王医生',
              diagnosis: '上呼吸道感染',
              status: '已完成'
            },
            {
              date: '2022-11-05',
              department: '神经内科',
              doctor: '李医生',
              diagnosis: '偏头痛',
              status: '已完成'
            },
            {
              date: '2022-08-20',
              department: '骨科',
              doctor: '张医生',
              diagnosis: '腰椎间盘突出',
              status: '随访中'
            }
          ]
        };
        
        // 滚动到详情区域
        this.$nextTick(() => {
          const detailCard = document.querySelector('.patient-detail-card');
          if (detailCard) {
            detailCard.scrollIntoView({ behavior: 'smooth' });
          }
        });
      },
      
      // 计算年龄
      calculateAge(birthDate) {
        if (!birthDate) return '';
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
          age--;
        }
        return age;
      },
      
      // 编辑患者信息
      editPatient() {
        this.editMode = true;
      },
      
      // 保存患者信息
      savePatient() {
        // 模拟保存操作
        this.$message({
          message: '患者信息保存成功',
          type: 'success'
        });
        this.editMode = false;
      },
      
      // 取消编辑
      cancelEdit() {
        this.editMode = false;
        // 实际应用中应该恢复原始数据，这里省略
      },
      
      // 打印
      printPatient() {
        this.$message({
          message: '正在准备打印患者档案',
          type: 'info'
        });
      },
      
      // 一键获取HIS系统患者档案
      fetchPatientData() {
        if (this.searchResultList.length === 0) {
          this.$message.warning('没有找到匹配的患者记录');
          return;
        }
        
        // 开始导入过程
        this.importDialogVisible = true;
        this.importProgress = 0;
        this.importPercentage = 0;
        this.importMessage = '正在连接HIS系统...';
        
        // 模拟导入过程
        setTimeout(() => {
          this.importProgress = 1;
          this.importPercentage = 25;
          this.importMessage = '已获取患者基础信息';
          
          setTimeout(() => {
            this.importProgress = 2;
            this.importPercentage = 50;
            this.importMessage = '正在同步账户信息...';
            
            setTimeout(() => {
              this.importProgress = 3;
              this.importPercentage = 75;
              this.importMessage = '正在同步扩展信息...';
              
              setTimeout(() => {
                this.importProgress = 4;
                this.importPercentage = 100;
                this.importStatus = 'success';
                this.importMessage = '档案同步完成！';
                
                // 关闭对话框，展示详情
                setTimeout(() => {
                  this.importDialogVisible = false;
                  this.viewPatientDetail(this.searchResultList[0]);
                }, 1000);
              }, 800);
            }, 1000);
          }, 1200);
        }, 1000);
      },
      
      // 查看就诊详情
      viewVisitDetail(visit) {
        this.$message({
          message: `查看就诊详情: ${visit.date} - ${visit.diagnosis}`,
          type: 'info'
        });
      },
      
      // 上传头像前处理
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
  
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        
        if (isJPG && isLt2M) {
          // 模拟上传成功
          this.patientDetail.avatar = URL.createObjectURL(file);
        }
        return false; // 阻止实际上传
      }
    }
  }
  </script>
  
  <style scoped>
  .patient-archive {
    padding: 20px;
  }
  
  .page-title {
    margin-bottom: 20px;
    font-weight: 500;
    color: #303133;
  }
  
  .search-card, .result-card, .patient-detail-card {
    margin-bottom: 20px;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .header-title {
    font-size: 16px;
    font-weight: 500;
    margin-right: 10px;
  }
  
  .empty-result, .empty-table-tip {
    text-align: center;
    padding: 30px 0;
    color: #909399;
  }
  
  .empty-result i, .empty-table-tip i {
    font-size: 30px;
    margin-bottom: 10px;
  }
  
  .patient-profile {
    display: flex;
    margin-bottom: 20px;
  }
  
  .profile-avatar {
    margin-right: 20px;
    position: relative;
  }
  
  .profile-avatar img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #eee;
  }
  
  .avatar-uploader {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  
  .avatar-uploader-icon {
    background-color: #409EFF;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: white;
  }
  
  .profile-info {
    flex: 1;
  }
  
  .profile-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .profile-header h3 {
    margin: 0;
    margin-right: 15px;
  }
  
  .medical-num {
    color: #909399;
    font-size: 13px;
  }
  
  .form-actions {
    margin-top: 20px;
    text-align: center;
  }
  
  .import-progress {
    text-align: center;
  }
  
  .progress-title {
    font-size: 16px;
    margin-bottom: 30px;
  }
  
  .progress-step {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
  }
  
  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80px;
  }
  
  .step-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #F2F6FC;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    margin-bottom: 8px;
    border: 2px solid #DCDFE6;
  }
  
  .step-item.active .step-icon {
    background-color: #409EFF;
    color: white;
    border-color: #409EFF;
  }
  
  .step-item.completed .step-icon {
    background-color: #67C23A;
    color: white;
    border-color: #67C23A;
  }
  
  .progress-line {
    height: 2px;
    background-color: #DCDFE6;
    flex: 1;
    margin: 0 5px;
  }
  
  .progress-line.active {
    background-color: #409EFF;
  }
  
  .progress-message {
    margin-bottom: 15px;
    color: #606266;
  }
  </style>